import {
  ChartNoAxesCombined,
  CheckCheck,
  CircleDollarSign,
  PiggyBank,
  ReceiptText,
  SquareDashed,
  WalletCards,
} from "lucide-react";
import { formatCurrency, progressPercentage } from "@/lib/goals";

const metricItems = (goal, progress, depositCount) => [
  {
    icon: PiggyBank,
    label: "Meta total",
    value: formatCurrency(goal.amount_cents),
    testId: "summary-meta-total",
  },
  {
    icon: WalletCards,
    label: "Já guardado",
    value: formatCurrency(goal.saved_cents),
    testId: "goal-metric-total-saved",
  },
  {
    icon: CircleDollarSign,
    label: "Quanto falta",
    value: formatCurrency(goal.remaining_cents),
    testId: "goal-metric-remaining",
  },
  {
    icon: ChartNoAxesCombined,
    label: "Concluído",
    value: `${progress}%`,
    testId: "goal-metric-percentage",
  },
  {
    icon: CheckCheck,
    label: "Quadradinhos concluídos",
    value: String(goal.marked_count),
    testId: "goal-metric-completed-squares",
  },
  {
    icon: SquareDashed,
    label: "Quadradinhos restantes",
    value: String(goal.square_count - goal.marked_count),
    testId: "goal-metric-remaining-squares",
  },
  {
    icon: ReceiptText,
    label: "Depósitos realizados",
    value: depositCount === null ? "—" : String(depositCount),
    testId: "goal-metric-deposit-count",
  },
];

export const GoalHeaderSummary = ({ goal, depositCount }) => {
  const progress = progressPercentage(goal);

  return (
    <section data-testid="goal-header-summary" className="cofre-summary-shell">
      <div className="grid grid-cols-2 divide-x divide-y divide-amber-200 sm:grid-cols-4 sm:divide-y-0">
        {metricItems(goal, progress, depositCount).map(({ icon: Icon, label, value, testId }) => (
          <div
            key={testId}
            data-testid={testId}
            className={`min-w-0 p-4 sm:p-5 ${testId === "goal-metric-deposit-count" ? "sm:col-span-2" : ""}`}
          >
            <div className="flex items-center gap-2 text-amber-800">
              <Icon className="h-4 w-4 shrink-0" />
              <span className="text-xs font-bold uppercase tracking-wide">{label}</span>
            </div>
            <p className="mt-2 font-heading text-lg font-extrabold text-emerald-950 sm:text-xl">
              {value}
            </p>
          </div>
        ))}
      </div>
      <div className="border-t border-amber-200 px-4 py-4 sm:px-5">
        <div className="flex items-center justify-between gap-4">
          <p className="text-base font-semibold text-emerald-950">Progresso do cofre</p>
          <p data-testid="summary-progress-percent" className="text-base font-bold text-emerald-800">
            {progress}% concluído
          </p>
        </div>
        <div
          data-testid="summary-progress-bar"
          className="mt-3 h-4 overflow-hidden rounded-full bg-amber-100"
          aria-label={`${progress}% concluído`}
        >
          <div
            className="cofre-progress-fill h-full rounded-full"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </section>
  );
};